import React from 'react';
import Cards from '@iso/components/uielements/card';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const CardComp = props => <Cards {...props} />;

const Card = styled(CardComp)`
.ant-card {
  border-radius: 20px !important;
}
  // .ant-card-head {
  //   background-color: ${palette('grayscale', 4)};
  //   ${'' /* border-bottom: 1px solid ${palette('border', 0)}; */} border-bottom: 0;

  //   .ant-card-head-title {
  //     color: ${palette('text', 0)};
  //   }
  // }

  .ant-card .ant-card-head {
    background-color: #ffffff;
    ${'' /* border-bottom: 1px solid ${palette('border', 0)}; */} border-bottom: 0;

    .ant-card-head-title {
      color: #5E6366;
      font-size: 14px;
      font-family: Poppins;
      font-weight: 500;
    }
  }

  .ant-card-extra {
    a {
      color: ${palette('primary', 0)};
      text-decoration: none;

      &:focus {
        text-decoration: none;
      }
    }
  }

  .ant-card-body {
    p {
      font-size: 13px;
      // color: ${palette('text', 3)};
      line-height: 1.5;
      // margin-bottom: 14px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &.ant-card-bordered {
    border: 1px solid ${palette('border', 0)};
    border-radius: 20px;

    .ant-card-head {
      border-bottom: 1px solid #f1f1f1;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      min-height: 46px;
      .ant-card-head-wrapper {
        .ant-card-head-title {
          color: #5E6366;
          font-weight: 450;
          font-size: 14px;
        }
      }
    }

    &:hover {
      border: 1px solid ${palette('border', 0)} !important;
    }
  }

  &.ant-card-loading {
    .ant-card-body {
      p {
        margin-bottom: 0;
      }
    }
  }

  .custom-card {
    padding: 10px 16px;
    h3 {
      color: ${palette('text', 1)};
      font-weight: 500;
    }
    p {
      color: ${palette('grayscale', 0)};
    }
  }
  
  &.custom-card.nodegroups {
    .ant-card-head{
      border-radius: 20px 20px 0 0;
      min-height: 46px;

      .ant-card-head-title{
        color: #7D7D7D;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
      }
    }

  }

  .custom-image img {
    display: block;
  }
`;

export default Card;
